[
    "albúmina",
    "albúmina",
    "aldioxa",
    "alantoína",
    "ácidos alfhidroxiácidos",
    "ácidos alfa-hidroxi",
    "ácidos alfa-hidroxi",
    "aminoácidos",
    "aminoácidos",
    "ácido aminosuccinato",
    "proteína hidrolizada de amonio",
    "ácido aspártico",
    "áspic",
    "beta caroteno",
    "biotina",
    "ácido benzoico",
    "cerda",
    "carbonato de calcio",
    "hidróxido de calcio",
    "lactato de calcio",
    "óxido de calcio",
    "fosfato de calcio",
    "estearato de calcio",
    "betaína caprílica",
    "óxido de caprilamina",
    "ácido caprílico",
    "carbón negro",
    "alcohol cetílico",
    "éter cetílico",
    "palmitato de cetilo",
    "alcohol cetílico",
    "palmitato de cetilo",
    "tiza",
    "carbón",
    "quitina",
    "colecalciferol",
    "quimosina",
    "color",
    "colores",
    "civeta",
    "corticoesteroide",
    "corticoesteroide",
    "cortisona",
    "cortisona corticoesteroide",
    "dexpantenol",
    "diglicéridos",
    "disodiuminositato",
    "colorante",
    "colorantes",
    "e129",
    "e133",
    "e170",
    "e322",
    "e470",
    "e570",
    "e585",
    "e631",
    "e640",
    "e901",
    "e910",
    "e920",
    "enzimas",
    "ergocalciferol",
    "estradiol",
    "grasas",
    "colores fd y c",
    "colores fd&c",
    "fieltro",
    "gluconolactona",
    "glucosamina",
    "ácido glutámico",
    "glicéridos",
    "glicerol",
    "glicina",
    "glucógeno",
    "hidrocortisona",
    "inositol",
    "insulina",
    "miristato de isopropilo",
    "ácido l-láctico",
    "ácido láctico",
    "lecitina",
    "leucina",
    "ácido linoleico",
    "lípidos",
    "lipoides",
    "lisina",
    "mono y di-glicéridos",
    "mono-diglicéridos",
    "monoglicéridos",
    "monoglicéridos glicéridos",
    "glutamato monosódico",
    "msg",
    "almizcle",
    "aceite de almizcle",
    "sulfato de éter miristal",
    "ácido mirístico",
    "sabor natural",
    "saborizantes naturales",
    "fuentes naturales",
    "ácidos nucleicos",
    "ácidos nucleicos",
    "dodecanol octílico",
    "estrógeno",
    "aceites",
    "ácido oleico",
    "ácido oleico",
    "alcohol oleico",
    "aceite oleico",
    "oleth",
    "miristato de oleílo",
    "palmitamida",
    "palmitamina",
    "palmitato",
    "ácido palmítico",
    "pantenol",
    "pantenilo",
    "polisorbatos",
    "polipéptidos",
    "lactato de potasio",
    "progesterona",
    "propilenglicol",
    "provitamina a",
    "provitamina b-5",
    "provitamina d-2",
    "amarillo quinolina",
    "rojo 40",
    "cuajo",
    "renina",
    "ácido ribonucleico",
    "arn",
    "hidrolizado de sacárido",
    "cera de abeja sorbitán",
    "monooleato de sorbitán",
    "monoestearato de sorbitán",
    "trioleato de sorbitán",
    "triestearato de sorbitán",
    "esponja",
    "escualano",
    "escualeno",
    "estearamida",
    "esteariamina",
    "óxido de esteariamina",
    "estearato",
    "estearatos",
    "ácido esteárico",
    "hidrazida esteárica",
    "ácido esteárico",
    "estearina",
    "estearona",
    "estearoxitrimetilsilano",
    "ácido lactílico estearoílo",
    "acetato de estearilo",
    "alcohol estearílico",
    "alcohol estearílico esteroles",
    "betaína estearílica",
    "caprilato de estearilo",
    "citrato de estearilo",
    "glicirretinato de estearilo",
    "heptanoato de estearilo",
    "imidazolina estearílica",
    "octanoato de estearilo",
    "estearato de estearilo",
    "tartrato de estearilo",
    "tartrato de estearilo",
    "esteroide",
    "esterol",
    "gamuza",
    "sebo",
    "amarillo sunset fcf",
    "tartrazina",
    "taurina",
    "testosterona",
    "treonina",
    "vitela",
    "terciopelo",
    "vitamina a",
    "vitamina b",
    "factor complejo vitamina b",
    "vitamina b1",
    "vitamina b12",
    "vitamina d3",
    "vitamina h",
    "amarillo5",
    "amarillo6"
]